import { Flex } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'
import type { DefaultProps } from 'typings'
import {
  Section,
  SectionContent,
  SectionHeader,
  SectionTitle,
} from '../Section'

export function Storefront(props: DefaultProps) {
  return (
    <Section>
      <SectionHeader>
        <Flex direction="column" align="baseline">
          <SectionTitle>
            <FormattedMessage id="admin/promotions.form.storefront.title" />
          </SectionTitle>
        </Flex>
      </SectionHeader>
      <SectionContent>{props.children}</SectionContent>
    </Section>
  )
}
